import Vue from 'vue';
import axios from 'axios';
import { BASE_URL } from '@/global/util/constants';
import { tip } from '@/global/util/util';
import Page from '@/global/util/Page';

const bus = new Vue()
const h = bus.$createElement
const BATCH_OPERATE = 'BATCH_OPERATE';

const state = {
  page: new Page()
};

const getters = {
  page: state => state.page
};

const mutations = {
  [BATCH_OPERATE](state, { ids, status }) {
    state.page.data = state.page.data.map(item => {
      if (ids.indexOf(item.id) > -1) {
        item.status = status;
      }
      return item;
    });
  }
};

const actions = {
  async getSupportInfoFlowData ({ state }, { request = axios.get, id }) {
    const res = await request(`${BASE_URL}/interface/place/information?place_id=${id}`)
    return res.data;
  },
  async getSupportInfoFlowMediaData ({ state }, { request = axios.get, medias }) {
    const res = await request(`${BASE_URL}/interface/place/information_media?medias=${medias.join(',')}`)
    return res.data;
  },
  async checkAdNameIsRepeat(
    { state, commit, rootState },
    { request = axios.get, name, platform }
  ) {
    const global = rootState.login.adType !== 'radio' ? 'global/' : ''

    const res = await request(
      `${BASE_URL}/${platform}/${global}ads/is-repeated?ad_name=${name}`
    );
    return res.data;
  },
  async checkLandpage ({ state, commit }, { request = axios.get, url, orderId, conversionMonitorType, jumpType, platform }) {
    const res = await request(`${BASE_URL}/${platform}/ads/ad/handle_url`, { order_id: orderId, url, conversion_monitor_type: conversionMonitorType, jump_type: jumpType })
    return res
  },
  async getPredictcover(
    { state, commit, rootState },
    { request = axios.post, platform, data }
  ) {
    const global = rootState.login.adType !== 'radio' ? 'global/ads' : 'ads/ad'
    const res = await request(
      `${BASE_URL}/${platform}/${global}/predictcover`,
      data
    );
    return res.data;
  },
  async getAd({ state, commit, rootState }, { request = axios.post, id, oid, platform }) {
    const global = rootState.login.adType !== 'radio' ? 'global/' : ''
    const order = rootState.login.adType !== 'radio' ? `?order_id=${oid}` : ''
    const res = await request(`${BASE_URL}/${platform}/${global}ads/${id}${order}`);
    return res.data;
  },
  async putAd({ state, commit, rootState }, { request = axios.put, id, data, platform }) {
    const global = rootState.login.adType !== 'radio' ? 'global/' : ''
    const res = await request(`${BASE_URL}/${platform}/${global}ads/${id}`, data);
    return res;
  },
  async addAd({ state, commit, rootState }, { request = axios.post, data, platform }) {
    const global = rootState.login.adType !== 'radio' ? 'global/' : ''
    const res = await request(`${BASE_URL}/${platform}/${global}ads`, data);
    return res;
  },
  async uploadBwList({ state, commit }, { request = axios.post, file }) {
    const formData = new FormData();
    formData.append('file', file);
    const res = await request(
      `${BASE_URL}/interface/black-white-upload`,
      formData
    );
    return res;
  },
  async downloadBwTemp({ state, commit, rootState }, { request = axios.get, platform }) {
    const global = rootState.login.adType !== 'radio' ? 'global/ads' : 'ads/ad'
    await request(`${BASE_URL}/${platform}/${global}/blackwhite`);
  },
  async getInfoFlowShowStyles(
    { state, commit },
    { request = axios.get, orderId, adFrom, platform }
  ) {
    const res = await request(`${BASE_URL}/${platform}/ads/ad/donewsplace`, {
      order_id: orderId,
      ad_from: adFrom
    });
    return res.data;
  },
  async uploadMaterial(
    { state, commit, rootState },
    { request = axios.post, file, information, platform } = {}
  ) {
    const global = rootState.login.adType !== 'radio' ? 'global/ads' : 'ads/ad'

    const formData = new FormData();
    formData.append('file', file);
    formData.append('information', information);
    const res = await request(
      `${BASE_URL}/${platform}/${global}/upload`,
      formData,
      {
        'Content-Type': 'multipart/form-data'
      }
    );
    return res.data;
  },
  async removeMaterial(
    { state, commit, rootState },
    { request = axios.get, ids, platform } = {}
  ) {
    const global = rootState.login.adType !== 'radio' ? 'global/ads' : 'ads/ad'
    const res = await request(
      `${BASE_URL}/${platform}/${global}/delplacematerials`,
      {
        ids: ids.join(',')
      }
    );
    return res;
  },
  async getMaterialSizes(
    { state, commit },
    { request = axios.get, id, information, platform, material_type } = {}
  ) {
    const res = await request(
      `${BASE_URL}/${platform}/ads/ad/getplacematerials`,
      {
        id,
        information,
        material_type
      }
    );

    return res.data;
  },
  async getSearchList({ state, commit, rootState }, { request = axios.get, platform }) {
    const global = rootState.login.adType !== 'radio' ? 'global/ads' : 'ads/ad'
    const res = await request(`${BASE_URL}/${platform}/${global}/selectlist`);
    return res.data;
  },
  async batchStop(
    { state, commit, rootState },
    { request = axios.post, ids, status, batch, platform }
  ) {
    const batchText = batch ? '批量' : '';
    const global = rootState.login.adType !== 'radio' ? 'global/' : ''

    try {
      await request(`${BASE_URL}/${platform}/${global}ads/batchstop`, { ids });
      commit(BATCH_OPERATE, { ids, status: status === '投放中' ? '暂停中' : '未在投放时间(暂停中)' });
      tip(`${batchText}暂停广告操作成功！`, { type: 'success' });
    } catch (error) {
      tip(`${batchText}暂停广告操作失败！`);
    }
  },
  async batchStart(
    { state, commit, rootState },
    { request = axios.post, ids, status, batch, platform }
  ) {
    const batchText = batch ? '批量' : '';
    const global = rootState.login.adType !== 'radio' ? 'global/' : ''

    try {
      const res = await request(`${BASE_URL}/${platform}/${global}ads/batchstart`, { ids });
      const unsetAds = res.data.unset_ads
      if (unsetAds && unsetAds.length > 0) {
        ids = ids.filter(id => !unsetAds.find(ad => ad.id == id))
        tip(h('div', {
          class: 'el-message__content'
        }, [
          ...unsetAds.map(ad => {
            return h('div', `广告 ${ad.id} 操作失败，原因：${ad.msg}`)
          })
        ]), { type: 'warning' })
      } else {
        tip(`${batchText}启用广告操作成功！`, { type: 'success' });
      }
      commit(BATCH_OPERATE, { ids, status: status === '暂停中' ? '投放中' : '未在投放时间(投放中)' });
    } catch (error) {
      tip(`${batchText}启用广告操作失败！`);
    }
  },
  async stopAd({ state, commit, rootState }, { request = axios.delete, id, platform }) {
    const global = rootState.login.adType !== 'radio' ? 'global/' : ''

    try {
      await request(`${BASE_URL}/${platform}/${global}ads/${id}`);
      commit(BATCH_OPERATE, { ids: [id], status: '已停止' });
      tip('停止广告操作成功！', { type: 'success' });
    } catch (error) {
      tip('停止广告操作失败！');
    }
  },
  async verifyAd(
    { state, commit, rootState },
    { request = axios.get, platform, id, data }
  ) {
    const global = rootState.login.adType !== 'radio' ? 'global/ads' : 'ads/ad'
    const res = await request(
      `${BASE_URL}/${platform}/${global}/verify/${id}`,
      data
    );
    return res;
  },
  async getVersions({ state, commit }, { request = axios.get, media }) {
    const res = await request(
      `${BASE_URL}/interface/etcd/item/version_oriented-media_${media}`
    );
    return res.data;
  },
  // 非管理员
  async getSuggestPrice(
    { state, commit, rootState },
    { request = axios.get, platform, data }
  ) {
    const global = rootState.login.adType !== 'radio' ? 'global/ads' : 'ads/ad'
    const res = await request(`${BASE_URL}/${platform}/${global}/bidding`, data);
    return res.data;
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
